import React from 'react'

import { useHistory } from 'react-router-dom'

import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

interface MissingPeriodSettingProps {
  embedded: boolean
  scaleFactor: number
}

/**
 * Shown when a widget is restricted to the latest closed
 * accounting period but the customer hasn't configured one.
 */
const MissingPeriodSetting = (props: MissingPeriodSettingProps) => {
  const { embedded, scaleFactor } = props
  const history = useHistory()
  const { isAdmin, isEconomist } = useAccountSettings()
  const { t } = useTranslation()

  const allowConfigure = !embedded && (isAdmin || isEconomist)

  return (
    <EmptyPlaceholder
      actions={
        allowConfigure ? (
          <Button onClick={() => history.push('/settings/economy')}>
            {t('widgets', 'configure_accounting_periods')}
          </Button>
        ) : undefined
      }
      background={true}
      title={t('widgets', 'missing_period_setting_error')}
      icon="WarningAmberOutlined"
      scaleFactor={scaleFactor}
    />
  )
}

export default MissingPeriodSetting
